import React from 'react'
import { useParameters } from '../contexts/ParametersContext';

const SequencingDetails = ({runs, displaySpecies, displayTissue = false}) => {
        
    const { parameters, updateParameters } = useParameters();
    
    const handleRemoveRun = (accession) => {
        const newSequencingRunList = parameters.startSection.sequencingRunList.filter(run => run.accession !== accession);
        
        if (newSequencingRunList.length === 0) {
            updateParameters({startSection: {sequencingRunList: newSequencingRunList, platform: ""}});
        } else {
            updateParameters({startSection: {sequencingRunList: newSequencingRunList}});
        }
    };
    
    return (
        <ul>
            {runs.map((run, index) => (
                <div key={index} className="run-infos" style={{position: 'relative'}}>
                    {displaySpecies && (
                        <button 
                            className="delete-btn remove-run-btn"
                            onClick={() => handleRemoveRun(run.accession)}
                            title={`Remove ${run.accession}`}
                        >
                            X
                        </button>
                    )}
                    <div className="run-unit">
                        <label>Accession:&nbsp;</label>
                        <a
                            href={`https://www.ncbi.nlm.nih.gov/sra/?term=${run.accession}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {run.accession} (≈{Math.round(run.size)} Gb FASTQ)
                        </a>
                    </div>
                    <div className='run-unit'>
                        <label>Total Bases (Mbp)</label>
                        <p>{Math.round(run.totalBases / 1e6).toLocaleString()} Mbp</p>
                    </div>
                    <div className="run-unit">
                        <label>Platform:&nbsp;</label>
                        <p>{run.platform} ({run.experimentInstrumentModel})</p>
                    </div>
                    <div className="run-unit">
                        <label>Layout:&nbsp;</label>
                        <p>{run.layout}</p>
                    </div>
                    <div className="run-unit">
                        <label>Strategy:&nbsp;</label>
                        <p>{run.strategy}</p>
                    </div>
                    <div className="run-unit">
                        <label>Selection:&nbsp;</label>
                        <p>{run.selection}</p>
                    </div>
                    {displayTissue && (
                        <div className="run-unit">
                            <label>Tissue:&nbsp;</label>
                            <p>{run.tissue || <span style={{ color: '#aaa', fontStyle: 'italic' }}>Not specified</span>}</p>
                        </div>
                    )}
                    {displaySpecies && (
                        <div className="run-unit">
                            <label>Species:&nbsp;</label>
                            <p>{run.scientificName}</p>
                        </div>
                    )}
                    {displaySpecies && parameters.species.scientificName && parameters.species.scientificName !== run.scientificName && (
                        <div className="run-unit">
                            <label></label>
                            <p><i>Warning: The sequenced organism differs from {parameters.species.scientificName}</i></p>
                        </div>
                    )}
                </div>
            ))}
        </ul>
    );
}

export default SequencingDetails